import {createRoot, hydrateRoot} from 'react-dom/client';
import CookiePolicy from '../pages/CookiePolicy/CookiePolicy'
import "../index.css";
import "../pages/CookiePolicy/CookiePolicy.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<CookiePolicy {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <CookiePolicy {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).CookiePolicyVC = {mount, hydrate, unmount}